module.exports = __webpack_public_path__ + "static/media/parallax-bg-01.ebbb8561.png";